import { render } from "./ManangeEvents.vue?vue&type=template&id=74fa0d78&scoped=true"
import script from "./ManangeEvents.vue?vue&type=script&lang=js"
export * from "./ManangeEvents.vue?vue&type=script&lang=js"

import "./ManangeEvents.vue?vue&type=style&index=0&id=74fa0d78&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fa0d78"]])

export default __exports__